<template>
  <form-group :validations="validation">
    <div slot-scope="{ errors, invalid }">

      <div class="form-group">
        <label class="text-right">{{ label }}</label>
        <input type="text" :value="inputValue" @input="updateValue" :class="invalid+' '+custom_class_on_input"
               class="form-control">
      </div>
      <form-errors-manager :errors="errors"/>
    </div>
  </form-group>
</template>
<script>
import FormGroup from "../../../validator/FormGroup.vue";
import FormErrorsManager from "../../../validator/FormErrorsManager.vue";

export default {
  name: "FormInput",
  components: {FormGroup, FormErrorsManager},
  props: ["validation", "inputValue", "label", 'custom_class_on_input'],
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
    }
  },
};
</script>